import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import 'rxjs/add/operator/filter';
import { MixpanelService } from './mixpanel.service';
import { RoutingstateService } from './routingstate.service';
import { LocationService } from '../locations/location.service';

@Component({
  selector: 'breadcrumbs',
  templateUrl: './breadcrumb.component.html',
})
export class BreadcrumbsComponent implements OnInit {
  breadcrumbs = [];
  previousRoute: any;
  commonDomain: any;
  pageName: string;
  userLocations = [];
  locationName: string;
  locationId: string;

  constructor(
    private router: Router,
    private mixpanel: MixpanelService,
    private routeState: RoutingstateService,
    private locationService: LocationService
  ) {}

  ngOnInit(): void {
    this.commonDomain = 'https://dashboard.sensorflow.org';
    this.previousRoute = this.routeState.getPreviousUrl();

    // get user assigned locations, we are assumimg that any location the user can access in the app is in this array
    this.locationService.getLocationsForUser().then((locations) => {
      this.userLocations = locations;
      // initial mount
      this.processBreadCrumbs();
    });

    // subscribe to route
    this.router.events
      .filter((event) => event instanceof NavigationEnd)
      .subscribe((event) => {
        this.processBreadCrumbs();
      });
  }

  private processBreadCrumbs() {
    // let rawcrumbs = [];
    // let currentRoute = this.route.root, url = '';

    // // TODO: clean up this code when we redo breadcrumbs, probably unncessary to fetch it this way
    // do {
    //   let childrenRoutes = currentRoute.children;
    //   currentRoute = null;
    //   childrenRoutes.forEach(route => {
    //     if (route.outlet === 'primary') {
    //       let routeSnapshot = route.snapshot;
    //       url += '/' + routeSnapshot.url.map(segment => segment.path).join('/');
    //       rawcrumbs.push({
    //         label: route.snapshot.data,
    //         url: url
    //       });
    //       currentRoute = route;
    //     }
    //   });

    // } while (currentRoute);

    // // leave these for logging and debug when we re-do this component
    // // console.warn(`This is the raw crumbs ${JSON.stringify(rawcrumbs, null, 2)}`);

    // // TODO: revamp the way we construct the breadcrumb listing properly, implemented in cumbersome way right now
    // let finalCrumbs = [];
    // let savedCrumbs = {};
    // for (let crumb of rawcrumbs) {
    //   let title = crumb.label.title;
    //   let isSaved = savedCrumbs[title];
    //   if (!isSaved) {
    //     finalCrumbs.push(crumb);
    //   }
    //   savedCrumbs[title] = true;
    // }

    // this.breadcrumbs = finalCrumbs.filter(item => item.label.title); // filter empty titles ""

    // new implementation below
    let newCrumbs = [
      {
        label: {
          title: 'Locations',
        },
        url: '/locations',
      },
    ];

    // get current url, split by slash, and construct the breadcrumbs manually
    // console.log(this.router);
    const currentUrl = this.router.url;
    const currentUrlParts = currentUrl.split('/');

    if (currentUrlParts.length >= 4) {
      this.locationId = currentUrlParts[2];
      this.locationName = this.userLocations.find(
        (location) => location.location_id === currentUrlParts[2]
      ).location_name;
    } else {
      // unset
      (this.locationId = ''), (this.locationName = '');
    }

    if (currentUrlParts.length >= 4 && this.locationName) {
      newCrumbs.push({
        label: {
          title: this.locationName,
        },
        url: `/locations/${currentUrlParts[2]}/rooms`,
      });
    }

    this.breadcrumbs = newCrumbs;

    // console.warn(`Final breadcrumbs now ${JSON.stringify(this.breadcrumbs, null, 2)}`);
  }

  trackBreadCrumbEvent(event) {
    // const originPageName = this.breadcrumbs[this.breadcrumbs.length - 1].label.title;

    // console.log(event);

    this.mixpanel.track('Use Breadcrumb Navigation', {
      $initial_referrer: `${this.commonDomain}${this.previousRoute}`,
      LocationId: this.locationId,
      LocationName: this.locationName,
      BreadcrumbLinkTextClicked: event.target.text,
      BreadcrumbLinkType: event.target.text === 'Locations' ? 'Locations List' : 'Rooms List',
      UseBreadcrumbNav: true,
    });
  }
}



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/shared/breadcrumb.component.ts